import React, { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import { IReport, IFunnelStageConfig, IFunnelStageData } from '../../api';
import { FunnelChart, FunnelDetails } from '../components/funnel';

const randomize = (stages: IFunnelStageConfig[]): IFunnelStageData[] => {
  const baseCount = Math.floor(Math.random() * (1000 - 500 + 1)) + 500;
  const decrementPercent = 20;

  return stages.map((stage: IFunnelStageConfig, index: number) => {
    const multiplier = Math.pow(1 - decrementPercent / 100, index);
    const count = Math.round(baseCount * multiplier);

    return {
      event: stage.value,
      value: count,
      label: stage.label,
      color: stage.color
    };
  });
}

const FunnelPreview: React.FC = () => {
  const { values, errors } = useFormikContext<IReport>();
  const [previewData, setPreviewData] = useState<IFunnelStageData[]>([]);

  useEffect(() => {
    // Vérifier si les stages sont valides (pas d'erreurs de validation)
    const stagesErrors = errors.stages;
    const hasNoErrors = !stagesErrors ||
      (Array.isArray(stagesErrors) && stagesErrors.every(err => !err));

    // Vérifier que tous les champs sont remplis
    const allFieldsFilled = values.stages?.every(stage =>
      stage.type && stage.value && stage.label && stage.color
    );

    if (hasNoErrors && allFieldsFilled && values.stages && values.stages.length > 0) {
      setPreviewData(randomize(values.stages));
    } else {
      setPreviewData([]);
    }
  }, [values.stages, errors.stages]);

  if (previewData.length === 0) {
    return (
      <p className="text-danger text-center">
        Complete all stage fields with valid data to see preview
      </p>
    );
  }

  return (
    <>
      <div className="text-center mb-4">
        <h3>Preview</h3>
        <small className="text-muted">Random and fictitious values for demonstration purposes</small>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-12">
          <FunnelChart
            options={{ showLegend: true }}
            data={previewData}
          />
        </div>
        <div className="col-lg-6 col-md-12">
          <FunnelDetails data={previewData} />
        </div>
      </div>
    </>
  );
};

export default FunnelPreview;
